import { EventType, SourcePages, Features } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';
import { VehicleEventInfo } from '../../types';

interface SellerSnapshotTapEventInfo extends VehicleEventInfo {
  action: string;
}

const event = ({ action, trackingParams }: SellerSnapshotTapEventInfo): EventData => {
  return {
    event_type: EventType.engagement,
    source_page: SourcePages.Vdp,
    feature: Features.sellerSnapshot,
    engagement_type: `${action}_tap`,
    event_context: {
      tracking_params: trackingParams,
    },
  };
};

export default event;
